import { apiRequest } from '@/domains/api';

/**
 * survey-api's public unsubscribe routes (SR-523 stage 3): anonymous, rate-limited, and the token
 * of a bulk mail's footer link the only input. Both answer the same whoever the address is; a bad,
 * tampered or expired token is 400 `mail-link-invalid`, and nothing more is said.
 */

const PUBLIC_MAIL = '/api/v1/public/mail';

function linkPath(action: 'unsubscribe' | 'resubscribe', token: string): string {
  return `${PUBLIC_MAIL}/${action}?${new URLSearchParams({ token })}`;
}

export interface IUnsubscribeAnswer {
  unsubscribed: boolean;
}

export const publicMailApi = {
  /** Whether the link's address is unsubscribed now — a read, which changes nothing. */
  state(token: string, signal?: AbortSignal): Promise<IUnsubscribeAnswer> {
    return apiRequest<IUnsubscribeAnswer>(linkPath('unsubscribe', token), { anonymous: true, signal });
  },

  /** The address the mail went to gets no more bulk mail. */
  unsubscribe(token: string): Promise<IUnsubscribeAnswer> {
    return apiRequest<IUnsubscribeAnswer>(linkPath('unsubscribe', token), { method: 'POST', body: {}, anonymous: true });
  },

  /** Its own unsubscribe undone; a complaint or staff's suppression stays. */
  resubscribe(token: string): Promise<IUnsubscribeAnswer> {
    return apiRequest<IUnsubscribeAnswer>(linkPath('resubscribe', token), { method: 'POST', body: {}, anonymous: true });
  }
};
